import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext.jsx";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { GetDataBusiness } from "../../../../api/GetData.jsx";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { AuthKPI } from "../../../../api/PostData.jsx";

const Login = () => {

  useEffect(() => {
    document.title = "KPI Login";
  }, []);


  const { setAuthData, setBusiness: setBusinessContext } = useAuth();
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [business, setBusiness] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const savedUserName = localStorage.getItem("userName");
    const savedPassword = localStorage.getItem("password");

    if (savedUserName && savedPassword) {
      setUserName(savedUserName);
      setPassword(savedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!business || !userName || !password) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Semua field harus diisi!",
        confirmButtonColor: "#1e40af"
      });
      return;
    }

    // if (rememberMe) {
    //   localStorage.setItem("business", business);
    //   localStorage.setItem("userName", userName);
    //   localStorage.setItem("password", password);
    // } else {
    //   localStorage.removeItem("business");
    //   localStorage.removeItem("userName");
    //   localStorage.removeItem("password");
    // }

    handleLogin();
  };

  const handleLogin = async () => {
    try {
      setLoading(true);
      const authKPI = await AuthKPI({
        busCode: business,
        username: userName,
        password: password,
      });

      console.log(authKPI);

      if (authKPI.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Login Berhasil",
          text: "Selamat datang di KPI Dashboard",
          confirmButtonColor: "#1e40af"
        });
        Cookies.set("token", authKPI.Token);
        setAuthData(authKPI.data);
        setBusinessContext(business);
        navigate("/kpi/dashboard");
      }

      // const response = await axios.get(
      //   `${baseURL}/get/kpi/user`,
      //   {
      //     params: {
      //       db: business,
      //       UserName: userName,
      //       pwd: password,
      //     },
      //   }
      // );

      // const userData = response.data;

      // if (!userData) {
      //   throw new Error("Login failed");
      // }

      // localStorage.setItem("dataLogin", JSON.stringify(userData));
      // localStorage.setItem("business", business);
      // Cookies.set("token", userData.Token);
      // setAuthData(userData);
      // navigate("/kpi/dashboard");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: "Cek username/password atau koneksi.",
        confirmButtonColor: "#1e40af"
      });
    } finally {
      setLoading(false);
    }
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // get data business
  const [dataBus, setDataBus] = useState([]);

  useEffect(() => {
    const fetchDataBus = async () => {
      try {
        const response = await GetDataBusiness();
        setDataBus(response);
      } catch (error) {
        console.log(error);
      }
    }
    fetchDataBus();
  }, []);


  return (
    <section className="bg-white min-h-screen">

      <div className="flex flex-col items-center justify-center mx-auto md:h-screen lg:py-0">
        <Link
          to="#"
          className="flex items-center mb-2 text-2xl font-semibold text-gray-900"
        >
          <img className="w-40" src="/img/MMG.png" alt="logo MMG" />
        </Link>
        <h1 className="text-2xl font-bold leading-tight tracking-tight text-blue-900 md:text-3xl">
          MAJU MOTOR GROUP
        </h1>

        <div className="w-full bg-blue-200 rounded-lg shadow md:mt-4 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Sign in to your account
            </h1>

            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="business"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Business
                </label>
                <select
                  id="business"
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 "
                  value={business}
                  onChange={(e) => setBusiness(e.target.value)}
                >
                  <option value="">Select a business</option>
                  {dataBus.length > 0 && dataBus.map((item) => (
                    <option value={item.BusCode}>{item.BusName}</option>
                  ))}

                </select>
              </div>

              <div>
                <label
                  htmlFor="userName"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Username
                </label>
                <input
                  type="text"
                  name="userName"
                  id="userName"
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
                  placeholder="username"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="••••••••"
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 pr-10"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? (
                      <FaEyeSlash className="w-4 h-4" />
                    ) : (
                      <FaEye className="w-4 h-4" />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      id="remember"
                      aria-describedby="remember"
                      type="checkbox"
                      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label
                      htmlFor="remember"
                      className="text-gray-500"
                    >
                      Remember me
                    </label>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="w-full text-white bg-blue-800 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                {loading ? (
                  <span className="animate-pulse">Loading...</span>
                ) : (
                  "Sign in"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
